

/// <reference path="appbase.ts" />
/// <reference path="../classes/LotInfoBox.ts" />

namespace TerminalApp {
    class StatusGroupItem extends LotInfoBox {
        dataContainer: HTMLElement;
        children: LotItem[] = [];
        auditForm: HTMLElement;
        error: HTMLElement;
        radio_name: string;
        reasonInput: HTMLInputElement;

        constructor(lotInfo: SP.StockingLotInfo) {
            super(lotInfo);

            this.dataContainer = this.inner_container.appendChild(document.createElement("div"));
            this.auditForm = this.inner_container.appendChild(document.createElement("div"));
            this.auditForm.classList.add("audit_form")
            this.radio_name = "reason_" + lotInfo.stockPlacementId + lotInfo.item.id;
            for (let key in SP.AuditReason) {
                if (isNaN(parseInt(key))) continue;

                let reasonRadio = document.createElement("input");
                reasonRadio.type = "radio";
                reasonRadio.value = key;
                reasonRadio.name = this.radio_name;
                let label = this.auditForm.appendChild(document.createElement("label"));
                label.innerHTML = " " + SP.AuditReason[key];
                label.prepend(reasonRadio);
            }

            this.error = this.auditForm.appendChild(document.createElement("div"));
            this.error.classList.add("error");

            this.reasonInput = this.auditForm.appendChild(document.createElement("input"));
            this.reasonInput.type = "text";
            this.reasonInput.maxLength = 100;
            this.reasonInput.placeholder = SP.Localize("word_reason_other");



            let confirmButton = this.auditForm.appendChild(document.createElement("button"));
            confirmButton.classList.add("grad-green");
            confirmButton.innerText = SP.Localize("word_save");
            confirmButton.addEventListener("click", () => this.post());
        }

        addChild(child: LotItem) {
            child.group = this;
            this.children.push(child);
            this.dataContainer.appendChild(child.container);
        }

        update() {
            let allOk = true;
            let hasDif = false;
            for (let i = 0; i < this.children.length; i++) {
                var child = this.children[i];
                if (!hasDif && child.diff != 0) hasDif = true;
                if (child.diff != 0 || !child.isOk) allOk = false;
            }

            if (allOk) {
                this.post(SP.AuditReason.StockAudit);
            }

            this.auditForm.style.display = hasDif ? "block" : "none";
        }

        async post(reason: number = null) {
            this.error.style.display = "none";

            let reasonId = reason;

            //get reason from checkbox
            if (reason == null) {
                var selectedReason = (document.querySelector('input[name="' + this.radio_name + '"]:checked') as HTMLInputElement);

                if (!selectedReason) {
                    this.error.innerHTML = SP.Localize("sentance_please_select_a_reason") + "!";
                    this.error.style.display = "block";
                    return;
                }
                reasonId = parseInt(selectedReason.value);
            }


            const reasonNote = this.reasonInput.value;
            const lotCounts: any = {};

            for (let i = 0; i < this.children.length; i++) {
                let child = this.children[i];
                var amount = Math.max(parseFloat(child.amountInput.value), 0);
                if (amount != child.data.placementQuantity)
                    lotCounts[child.data.id] = amount;
            }

            var data = {
                lotCounts: lotCounts,
                placementId: this.placementId,
                note: reasonNote,
                reason: reasonId
            };


            var result = await SP.post<any>("/api/v1/audit/commit/", data);


            if (result.status != 200) {
                await SP.alertX(result.status + ": " + result.msg);
            }
            else {
                for (let i = 0; i < this.children.length; i++) {
                    let child = this.children[i];
                    child.commit();
                }

                console.log("value:", reasonId);
                this.auditForm.style.display = "none";
            }


        }
    }


    class LotItem {
        container: HTMLElement;
        group: StatusGroupItem;
        amountInput: HTMLInputElement;
        isOk: boolean = false;
        diff: number = 0;
        data: SP.StockingLotInfo;
        infoBox: HTMLElement;
        constructor(lotInfo: SP.StockingLotInfo) {
            this.container = document.createElement("div");
            this.container.classList.add("lot_status_box", "noselect");
            this.data = lotInfo;

            //Headline
            var headline = this.container.appendChild(document.createElement("div"));
            headline.classList.add("lot_headline");
            headline.innerHTML += `<b>${SP.Localize("word_arrived")}: </b>${lotInfo.arrivalDate} (${lotInfo.createUser})`;
            if (lotInfo.expirationDate) headline.innerHTML += `<br><b>${SP.Localize("word_expiration")}:</b> ${lotInfo.expirationDate}`
            if (lotInfo.batchNumber) headline.innerHTML += `<br><b>${SP.Localize("word_batch")}:</b> ${lotInfo.batchNumber}`

            //config
            let configButton = this.container.appendChild(document.createElement("div"));
            configButton.classList.add("button", "config", "grad-gray");
            configButton.innerHTML = '<i class="fa-solid fa-gear"></i>';


            configButton.addEventListener("click", () => {
                editLotAssistant.open(lotInfo);
            });


            //minus
            let minusButton = this.container.appendChild(document.createElement("div"));
            minusButton.classList.add("button", "minus", "grad-gray");
            minusButton.innerHTML = '<i class="fas fa-minus"></i>';

            //inputBox
            let inputBox = this.container.appendChild(document.createElement("div"));
            inputBox.classList.add("input_box");

            //input
            this.amountInput = document.createElement("input");
            this.amountInput.name = "lot_count_" + this.data.id;
            this.amountInput.type = "number";
            this.amountInput.value = this.data.placementQuantity.toString();
            inputBox.innerHTML += ` / ${this.data.placementQuantity.toString()}`;
            inputBox.prepend(this.amountInput);

            //startcount
            let originalCount = inputBox.appendChild(document.createElement("span"));
            originalCount.innerHTML = " / " + this.data.initialQuantity.toString();

            //plus
            let plusButton = this.container.appendChild(document.createElement("div"));
            plusButton.classList.add("button", "plus", "grad-gray");
            plusButton.innerHTML = '<i class="fas fa-plus"></i>';

            //info
            let infoBox = this.infoBox = this.container.appendChild(document.createElement("div"));
            infoBox.classList.add("info");
            infoBox.innerHTML = "OK";

            infoBox.addEventListener("click", () => {
                if (!this.isOk)
                    this.update(true);
            });



            this.amountInput.addEventListener("input", () => this.update(false,true,true));

            this.amountInput.addEventListener("focus", e => {
                this.amountInput.select();
            });



            plusButton.addEventListener("click", () => {
                this.amountInput.value = (parseFloat(this.amountInput.value) + 1).toString();
                this.update();
            });

            minusButton.addEventListener("click", () => {
                this.amountInput.value = (parseFloat(this.amountInput.value) - 1).toString();
                this.update();
            });
        }

        commit() {
            var amount = Math.max(parseFloat(this.amountInput.value), 0);
            this.data.placementQuantity = amount;
            this.update(true, false);
        }


        update(approve = false, updateGroup = true, fromInput = false) {
            var amount = Math.max(parseFloat(this.amountInput.value), 0);
            if (isNaN(amount)) amount = 0;
            if (!fromInput)
            this.amountInput.value = amount.toString();

            this.diff = normalize(amount - this.data.placementQuantity);
            this.infoBox.style.backgroundColor = this.diff > 0 ? "#ecf1ab" : this.diff < 0 ? "#efc6c6" : approve ? "#bae0ba" : "";
            this.infoBox.innerHTML = this.diff == 0 ? "OK" : (this.diff > 0 ? "+" : "") + this.diff.toString();


            this.isOk = approve && this.diff == 0;

            if (updateGroup) this.group.update();
        }


    }

    class app_audit_stock extends AppBase {
        bound = false;
        input_stock = document.getElementById("audit_stock_stock") as HTMLSelectElement;
        input_popup = new Input_Popup();

        currentCustomerId: string = "";
        currentItemId: string = "";
        currentPlacementId: number = -1;
        currentBarcode: string = "";

        button_search_ean = document.getElementById("cs_search_ean");
        button_search_item = document.getElementById("cs_search_item");
        button_pick_placement = document.getElementById("cs_search_placement");
        header_container = document.querySelector(".cs .placement_header");

        audit_stock_data = document.getElementById("audit_stock_data");
        audit_stock_info = document.getElementById("audit_stock_info");
        audit_stock_info_image = this.audit_stock_info.querySelector("img");
        audit_stock_no_items = document.getElementById("audit_stock_no_items");

        constructor() {
            super("app_audit_stock");


            this.button_search_item.addEventListener("click", () => {
                itemSearchAssistant.open(this.currentCustomerId, "", false, (item) => {
                    this.selectItem(item.id);
                });
            });

            this.button_search_ean.addEventListener("click", () => {
                itemSearchAssistant.open(this.currentCustomerId, "", true, (item) => {
                    this.selectItem(item.id);
                });
            });

            this.button_pick_placement.addEventListener("click", () => {
                placementPickerAssistant.open(null, null, (p) => {
                    this.selectPlacementId(p.id, "");
                });
            });

            this.audit_stock_info_image.style.pointerEvents = "all";
            this.audit_stock_info_image.addEventListener("click", () => {
                placementPickerAssistant.open(null, null, (p) => {
                    this.scanPlacement(p.id.toString());
                });
            });

        }

        reset() {
            this.clearData();
            this.currentCustomerId = "";
            this.currentItemId = "";
            this.currentPlacementId = -1;
            this.currentBarcode = "";
            this.audit_stock_info.style.display = "block";
            this.audit_stock_no_items.style.display = "none";
            this.input_popup.hide();
        }

        async onOpen() {
            this.reset();

            var filter = SP.getHash("filter") ?? "";
            await this.selectPlacementId(SP.getHash("placementId") as any, filter);
            await this.selectItem(SP.getHash("itemId"));
            await this.selectBarcode(SP.getHash("barcode"));

            this.currentCustomerId = SP.getHash("customerId");
            
            //bind events and groups
            if (!this.bound) {
                this.bound = true;
                barcodeListener.on("sp", this.scanPlacement, this);
                barcodeListener.on("t", this.scanTote, this);
                barcodeListener.on(null, this.scanBarcode, this);
            }
        }

        async onClose() {
            //unbind events and groups
            if (this.bound) {
                this.bound = false;
                barcodeListener.off("sp", this.scanPlacement);
                barcodeListener.off("t", this.scanTote);
                barcodeListener.off(null, this.scanBarcode);
            }

            itemSearchAssistant.close();
            placementPickerAssistant.close();

            this.reset();
        }



        async selectBarcode(barcode: string) {
            if (!barcode) return;
            if (this.currentBarcode != barcode) {
                StartLoading();
                this.currentBarcode = barcode;
                this.currentPlacementId = null;
                this.currentItemId = null;

                ignoreHashChange = true;
                SP.setManyHash({ "barcode": barcode, "placementId": null, "itemId": null });
                this.setData(await SP.Data.StockingLot.getBarcodeStockingLotInfos(barcode, false));
            }
        }




        async selectPlacementId(placementId: number, filter: string) {
            if (!placementId) return;


            StartLoading();
            this.currentPlacementId = placementId;
            this.currentBarcode = null;
            this.currentItemId = null;

            ignoreHashChange = true;
            SP.setManyHash({ "placementId": placementId.toString(), "barcode": null, "itemId": null });


            //get items
            var infos: SP.StockingLotInfo[] = [];

            var response = await SP.get<any>("/api/v1/info/stockingLotInfos/?maxResults=10000&placementId=" + placementId + "&itemFilter=" + filter);
            if (response.status == 200) infos = response.data;

            //Too many Items (must filter)
            else if (response.status == 519) {
                SP.Sounds.Error.play();
                this.input_popup.show("Too many items on location, filter or scan item!", "Filter", "Filter / ean ...", async () => {
                    await this.selectPlacementId(placementId, this.input_popup.value);
                });
                StopLoading();
                return;
            }

            this.setData(infos);

        }

        async selectItem(itemId: string) {
            if (!itemId) return;


            if (this.currentItemId != itemId) {
                StartLoading();
                this.currentItemId = itemId;
                this.currentBarcode = null;
                this.currentPlacementId = null;

                ignoreHashChange = true;
                SP.setManyHash({ "itemId": itemId, "barcode": null, "placementId": null });
                this.setData(await SP.Data.StockingLot.getItemStockingLotInfos(itemId, false));
            }

        }

        clearData() {
            //clear previous data
            this.groupData = {};
            this.audit_stock_data.innerHTML = "";

        }

        groupData: { [key: string]: StatusGroupItem };
        setData(lots: SP.StockingLotInfo[]) {
            console.log("got data:", lots);

            this.clearData();

            for (let i = 0; i < lots.length; i++) {
                let lot = lots[i];
                let key = lot.item.id + "-" + lot.stockPlacementId;
                let group = this.groupData[key];

                if (group == null) {
                    group = this.groupData[key] = new StatusGroupItem(lot);
                    this.audit_stock_data.appendChild(group.container);
                }

                var lotItem = new LotItem(lot);
                group.addChild(lotItem);
            }

            SP.Sounds.Click.play();
            StopLoading();
            this.audit_stock_info.style.display = "none";
            this.audit_stock_no_items.style.display = lots.length ? "none" : "block";


        }


        async scanTote(scanId: string) {
            var ti = await SP.Data.Tote.getToteInfo(scanId, false);
            this.selectPlacementId(ti.totePlacementId, '');
        }

        async scanPlacement(scanId: string) {
            this.selectPlacementId(parseInt(scanId), '');
        }

        async scanBarcode(barcode: string) {
            if (this.input_popup.open) {
                this.input_popup.setExecute(barcode);
            }

            if (!this.currentCustomerId) {
                this.selectBarcode(barcode);
            }

            else {
                //auto search
                itemSearchAssistant.open(this.currentCustomerId, barcode, false, (i) => {
                    this.selectItem(i.id);
                });
            }
        }

    }
    RegisterApp("app_audit_stock", app_audit_stock);
}